// src/tiles/ImpressionTile.jsx
import React from 'react';
import TileShell from './TileShell';
import PrimaryScorePill from './PrimaryScorePill';
import ScoreBadge from './ScoreBadge';
import InterviewsBadge from './InterviewsBadge';
import ReceiptsList from './ReceiptsList';
import VariantPill from './VariantPill';
import { scoreHelp } from '../../utils/scoreHelp';

export default function ImpressionTile({ title, count, variant, score, receipts, importance, sectionTotal }) {
  const isPos = variant === 'positive';
  const help = isPos ? scoreHelp.impressionPos : scoreHelp.impressionNeg;
  const label = help.label; // 'Positivity Score' | 'Negativity Score'
  const tone = isPos ? 'green' : 'red';
  const info = `${help.calc}\n${help.meaning}`;

  const primaryScore = (
    <PrimaryScorePill
      label={label}
      value={score}
      infoTooltip={info}
      tone={tone}
    />
  );

  const pct = sectionTotal ? Math.round((count / sectionTotal) * 100) : 0;
  const metricsRow = (
    <div style={{ display:'flex', flexWrap:'wrap', gap:8 }}>
      <InterviewsBadge percent={pct} count={count} />
      <ScoreBadge
        label="Importance"
        value={importance}
        metricKey={isPos ? 'positive_importance' : 'drawback_importance'}
      />
    </div>
  );

  return (
    <TileShell
      typePill="impression"
      variantPill={<VariantPill variant={variant} />}
      title={title}
      primaryScore={primaryScore}
      metricsRow={metricsRow}
      receipts={<ReceiptsList receipts={receipts || []} />}
    />
  );
}


